import React from 'react';
import TimersRegistry from './TimersRegistry';
import LanternTimer from './LanternTimer';

// FIXME: migrate to HOC and use composition instead of inheritance
export default class TimedView extends React.Component {
    /**
     * Returns true if the timer with the specified name is ticking
     */
    static isTimerRunning(timerName) {
        return TimersRegistry.get(timerName).isRunning();
    }

    /**
     * Pause the timer specified by timerName
     */
    static pauseTimer(timerName) {
        if (timerName && TimersRegistry.has(timerName) && TimedView.isTimerRunning(timerName)) {
            TimersRegistry.get(timerName).pause();
        }
    }

    /**
     * Resume the timer specified by timerName
     */
    static resumeTimer(timerName) {
        if (timerName && TimersRegistry.has(timerName) && !TimedView.isTimerRunning(timerName)) {
            TimersRegistry.get(timerName).resume();
        }
    }

    constructor(props) {
        super(props);
        this.timerNames = [];
        this.getTimer = this.getTimer.bind(this);
        this.createStopwatch = this.createStopwatch.bind(this);
        this.scheduleEvent = this.scheduleEvent.bind(this);
        this.resetTimers = this.resetTimers.bind(this);
    }

    /**
     * Returns the timer specified by timerName
     */
    getTimer(timerName) {
        if (timerName && this.timerNames.includes(timerName)) {
            return TimersRegistry.get(timerName);
        }
        return null;
    }

    /**
     * Get plain old timer that ticks each `unit` time period
     * @param  {string} timerName name of the timer
     * @param  {string} units (optional) precision of the timer, default is "seconds"
     * @return {LanternTimer} timer instance, can be paused/resumed
     */
    createStopwatch(timerName, units) {
        const timer = this.createTimer(timerName, units);
        timer.startChronometer();

        return timer;
    }

    /**
     * Execute passed function with delay
     * @param  {string} timerName name of the timer
     * @param  {Function} callback function to be executed
     * @param  {number} timeDelay to wait before execution
     * @param  {string} units (optional) of passed `timeDelay`, default is "seconds"
     * @return {LanternTimer} instance of countdown timer, can be paused/resumed
     */
    scheduleEvent(timerName, callback, timeDelay, units) {
        const timer = this.createTimer(timerName, units);
        timer.startCountdown(() => {
            this.resetTimer(timerName);
            callback();
        }, timeDelay);

        return timer;
    }

    /**
     * Stop all the timers created by the view
     */
    resetTimers() {
        this.timerNames.forEach((key) => {
            TimersRegistry.get(key).stop();
            TimersRegistry.remove(key);
        });
        this.timerNames = [];
    }

    /**
     * Stop the timer specified by timerName
     */
    resetTimer(timerName) {
        if (timerName && TimersRegistry.has(timerName)) {
            TimersRegistry.get(timerName).stop();
            TimersRegistry.remove(timerName);
        }
        this.timerNames = this.timerNames.filter((el) => el !== timerName);
    }

    /**
     * Pause all the timers created by the view
     */
    pauseTimers() {
        this.timerNames.forEach((timerName) => {
            TimedView.pauseTimer(timerName);
        });
    }

    /**
     * Resume all the timers created by the view
     */
    resumeTimers() {
        this.timerNames.forEach((timerName) => {
            TimedView.resumeTimer(timerName);
        });
    }

    createTimer(timerName, units) {
        if (timerName) {
            if (TimersRegistry.has(timerName)) {
                this.resetTimer(timerName);
            }
            const timer = new LanternTimer(timerName, units);
            TimersRegistry.put(timerName, timer);
            this.timerNames.push(timerName);

            return timer;
        }

        throw new Error('timerName cannot be empty.');
    }

    render() {
        return null;
    }
}
